import { render } from "./vent-holes.vue?vue&type=template&id=73146bbc"
import script from "./vent-holes.vue?vue&type=script&lang=js"
export * from "./vent-holes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__